import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {
  selectGroupAccess,
  selectGroupAccessLoaded,
  selectIsUserAccessAndColleaguesLoading,
  selectUserAccess,
  selectUserAccessLoadingPresentation,
  selectLastFailedStaffAccessCreateUserId,
} from '../../user-access-store/user-access.selectors';
import {IGroupAccess} from '../../models/group-access';
import {getGroupAccessSettings} from '../../user-access-store/user-access.actions';
import {selectColleagues} from '../../../core/store-shared/shared.selectors';
import {getColleagues} from '../../../core/store-shared/shared.actions';
import {IColleagues} from '../../models/colleague-user';
import {IUserAccessOperationProgress} from '../../models/user-access-operation-progress.interface';
import {selectUser} from '../../user-store/user.selectors';
import {getUserStores} from '../../user-stores-store/user-store.actions';
import {selectStores} from '../../user-stores-store/user-store.selectors';
import {IUserAccess} from '../../models/user-access';
import {IUser} from '../../models/user/user';
import {IStore} from '../../../../shared/shared-models/store/store';

@Component({
    selector: 'app-user-access-page-container',
    templateUrl: './user-access-page-container.component.html',
    styleUrls: ['./user-access-page-container.component.scss'],
    standalone: false
})
export class UserAccessPageContainerComponent implements OnInit {

  currentUser$: Observable<IUser>;
  colleaguesFromState$: Observable<IColleagues>;
  storesFromState$: Observable<IStore[]>;
  currentUserAccess$: Observable<IUserAccess>;
  isLoading$: Observable<boolean>;
  loadingPresentation$: Observable<IUserAccessOperationProgress | null>;
  lastFailedStaffAccessCreateUserId$: Observable<string | null>;
  groupAccess$: Observable<IGroupAccess>;

  constructor(
    private readonly store: Store,
  ) {
  }

  ngOnInit(): void {
    this.store.dispatch(getUserStores({pageStoreDocument: 'user-access'}));
    this.store.dispatch(getColleagues());
    this.store
      .select(selectGroupAccessLoaded)
      .pipe(take(1))
      .subscribe((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(getGroupAccessSettings());
        }
      });

    this.currentUser$ = this.store.select(selectUser);
    this.currentUserAccess$ = this.store.select(selectUserAccess);
    this.colleaguesFromState$ = this.store.select(selectColleagues);
    this.storesFromState$ = this.store.select(selectStores);
    this.isLoading$ = this.store.select(selectIsUserAccessAndColleaguesLoading);
    this.loadingPresentation$ = this.store.select(selectUserAccessLoadingPresentation);
    this.lastFailedStaffAccessCreateUserId$ = this.store.select(selectLastFailedStaffAccessCreateUserId);
    this.groupAccess$ = this.store.select(selectGroupAccess);
  }

}
